import { Navigate } from "react-router-dom"
import { useAuth } from "../../Components/ProtectedRoute/ProtectedRoute"

export const RequireAuth = ({ children }) => {
    
    const auth = useAuth()

    if(!auth.user) {
        return <Navigate to ='/Login' />
    }
    return children
};